import { FC, useEffect, useState } from 'react'
import { Image } from 'react-bootstrap'
import { check_di_empty, check_di_full, check_en_empty, check_en_full } from 'src/assets'
import { dict, fitem_t } from 'src/types'
import { join_str } from 'src/utils'

const SVG: dict<string> = {
  'di-full': check_di_full,
  'en-full': check_en_full,
  'di-empty': check_di_empty,
  'en-empty': check_en_empty,
}

export const CheckBox: FC<fitem_t> = ({
  id,
  label,
  required,
  disabled,
  capture = 'false',
  error,
  fired,
  classes = 'w-100',
  classes_field = 'd-flex align-items-center width-fit-content cursor-pointer',
  classes_label = 'm-0 p-0 font-20 c-7f7f7f d-flex align-items-center cursor-pointer',
  classes_error = 'm-0 p-0 ml-2 font-12-semibold c-error text-uppercase',
  classes_disabled = 'c-7f7f7f cursor-not-allowed',
  set_field_value,
}: fitem_t) => {
  /**
   * Use State
   */
  const [checked, set_checked] = useState(JSON.parse(capture || 'false'))

  /**
   * Use Effect
   */
  useEffect(() => {
    set_field_value?.(id, JSON.stringify(checked))
  }, [checked])

  /**
   * Alias
   */
  const svg_name_1 = disabled ? 'di' : 'en'
  const svg_name_2 = checked ? 'full' : 'empty'
  const svg_name = `${svg_name_1}-${svg_name_2}`
  const end = required && !disabled ? '*' : ''
  const classes_ = {
    label: join_str(
      classes_label || 'd-none',
      label ? '' : 'opacity-0',
      disabled ? classes_disabled : ''
    ),
    error: join_str(classes_error || 'd-none', fired && error ? '' : 'opacity-0'),
  }

  /**
   * Render functions
   */
  const render_label = () => (
    <label htmlFor={id} className={classes_.label}>
      <Image src={SVG[svg_name]} className="m-0 p-0 mr-2" width={16} height={16} />
      {`${label}${end}`}
      <span className="opacity-0">-</span>
    </label>
  )

  const render_error = () => (
    <p className={classes_.error}>
      {error}
      <span className="opacity-0">-</span>
    </p>
  )

  const render_field = () => (
    <div className={classes_field}>
      <input
        id={id}
        type="checkbox"
        disabled={disabled}
        hidden={true}
        onClick={() => set_checked(!checked)}
      />
      {render_label()}
      {render_error()}
    </div>
  )

  return (
    <main className={classes} style={{ zIndex: 10 }}>
      {render_field()}
    </main>
  )
}
